<button
  id="kng-open-modal"
  [hidden]="true"
  type="button"
  data-bs-toggle="modal"
  data-bs-target="#kng-modal" tabindex="0"
>
  Open Modal
</button>

<div
  class="modal kng-modal"
  [ngClass]="{'modal-overflow-hide' : checkBoxText}"
  id="kng-modal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  attr.aria-hidden="{{ state.hidden }}"
  role="dialog"
  aria-labelledby="kng-modal-content"
  aria-label="Modal"

>
  <div
    id="kng-modal-content"
    class="modal-dialog modal-dialog-centered modal-lg"
    role="document"
  >
    <div class="modal-content kng-modal--{{ state.cssClass }}">
      <div class="kng-modal--header">
        <div class="kng-modal--title" tabindex="0">
          {{ state.label }}
          <div class="tooltip-desktop" *ngIf="state.tooltip?.content">
          <img class="icon" *ngIf="state.closeHidden"  alt='Tooltip-indicator' src="/assets/modal_tooltip.svg" (keyup.enter)="openTooltip(toolTipRef)" (mouseenter)="openTooltip(toolTipRef)" (mouseleave)="closeTooTip(toolTipRef)" tabindex="0" >
          <div *ngIf="state.closeHidden" [ngClass]="{'terms_condition_tooltip--hidden' : !showTooltip}" class="terms_condition_tooltip"
          #toolTipRef role="dialog"><p class="toolTip-text">{{state.tooltip?.content}}</p></div>
        </div>
        <div class="tooltip-mobile" *ngIf="state.tooltip?.content">
          <img class="icon" *ngIf="state.closeHidden"  alt='Tooltip-indicator' src="/assets/modal_tooltip.svg" matTooltipPosition="below" tabindex="0" (click)="showMobileTooltip()" tabindex="0" attr.aria-label="{{ state.tooltip?.content }}" >
        </div>
        </div>

        <button *ngIf="!state.closeHidden"
          type="button"
          id="kng-modal-close"
          class="btn-close ml-auto"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closePopup()" tabindex="0"
        ></button>
      </div>

      <div class="kng-modal--body" [ngClass]="{'kng-modal--body-max-height' : checkBoxText || state.checkboxText}" [ngClass]="{'modal-overflow-hide' : state.checkboxText}">
        <ng-content></ng-content>
      </div>
      <div class="kng-modal--footer">
        <div class="kng-modal--navBtnContainer" *ngIf="navBtnState.btnRequired" (click)="navBtnclick()">
          <span class="arrow"><img [src]="arrowLeft"></span>
          <button class="kng-modal--navBtn">{{navBtnState.btnLabel}}</button>
        </div>
        <div class="kng-modal--check-box-container" *ngIf="state.isCheckBox">
          <mat-checkbox class="kng-modal--check-box" [ngClass]="{'kng-modal--check-box-pad' : checkBoxText || state.checkboxText}" [disabled]="checBoxDisabledFlag" [(ngModel)]="checkBoxTickedFlag"  (change)="checkBoxClickEvent()">{{checkBoxText}}</mat-checkbox>
        </div>
        <div class="kng-modal--check-box-container" *ngIf="state.checkboxText">
          <mat-checkbox class="kng-modal--check-box" [ngClass]="{'kng-modal--check-box-pad' : checkBoxText || state.checkboxText}" [disabled]="checBoxDisabledFlag" [(ngModel)]="checkBoxTickedFlag"  (change)="checkBoxClickEvent()">{{state.checkboxText}}</mat-checkbox>
        </div>
        <div class="btn-container">
          <button
            type="button"
            class="btn kng-modal--action-button kng-modal--{{ cta.cssClass }}"
            [ngClass]="{'kng-modal--action-button-mob-wid' : checkBoxText || state.checkboxText}"
            *ngFor="let cta of state.buttons"
            [hidden]="cta.hidden"
            (click)="emitCtaClickEvent(cta)"
            [disabled]="cta.disabled" tabindex="0"
          >
            <img
              *ngIf="cta.iconPath"
              class="kng-modal--action-button-icon"
              src="{{ cta.iconPath }}"
              alt=""
            />
            <span>{{ cta.label }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
